import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';

import style from './block.module.scss';

function Number() {
    return (
        <BlockWrapper className={style.block}>
            <EditableText
                tagName={'p'}
                smartProp={'number'}
                placeholder={'Insérez le chiffre'}
                className={style.number}
                allowedFormats={['advanced/outlined']}
            />
            <EditableText tagName={'p'} smartProp={'text'} placeholder={'Insérez le texte'} className={style.text} />
        </BlockWrapper>
    );
}

export default defineBlock({
    Block: Number,
    smartProps: {
        number: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Number',
        parent: ['smartfire/numbers'],
    },
});
